import React, { useEffect, useState } from 'react'
import { Button } from '../Button'
import Modal from '../Modal/Modal'
import { AlertsService } from '../../services/alerts.service'
import {
  AlertContent,
  AlertTitle,
  AlertHtmlContent,
  AlertButtonContainer,
  IconContainer
} from './styled'
import { Icon } from 'components/Icon'

interface Alert {
  id: string
  title: string
  htmlContent: string
  icon?: string
  url?: string
}

interface AlertsModalProps {
  visible: boolean
  alert: Alert | null
  onClose: () => void
}

const iconMapping = [
  'newspaper',
  'news',
  'news2',
  'article',
  'announcement',
  'before',
  'default'
]

const AlertsModal: React.FC<AlertsModalProps> = ({ alert, onClose }) => {
  const [isVisible, setIsVisible] = useState(false)
  const alertsService = new AlertsService()

  useEffect(() => {
    if (alert) {
      setIsVisible(true)
      return () => setIsVisible(false)
    }
  }, [alert])

  if (!alert) return null

  // Get the appropriate icon path from the mapping or use default
  const iconSrc = iconMapping.includes(alert.icon || '')
    ? alert.icon
    : 'newspaper'

  const handleMarkAsSeen = async (seen: boolean) => {
    try {
      onClose()
      if (seen && alert.url) {
        await alertsService.markAlertAsSeen(alert.id)
        if (alert.url) {
          window.location.href = alert.url
        }
      }
    } catch (error) {
      console.error('Erro ao marcar alerta como visualizado:', error)
    }
  }

  const content = (
    <AlertContent isVisible={isVisible}>
      <IconContainer>
        {iconSrc && <Icon icon={iconSrc} width={100} height={100} />}
      </IconContainer>
      <AlertTitle>{alert.title}</AlertTitle>
      <AlertHtmlContent
        dangerouslySetInnerHTML={{ __html: alert.htmlContent }}
      />
    </AlertContent>
  )

  return (
    <Modal
      content={content}
      isPersonButtons={true}
      button={
        <AlertButtonContainer>
          {alert.url && (
            <Button
              variant="primary"
              onClick={() => handleMarkAsSeen(true)}
              className="alert-action-button"
            >
              Quero conhecer agora!
            </Button>
          )}
          <Button
            variant="default"
            onClick={() => handleMarkAsSeen(false)}
            className="alert-later-button"
          >
            Ver mais tarde
          </Button>
        </AlertButtonContainer>
      }
      cancelButton={false}
      onExit={onClose}
      width={50}
    />
  )
}

export default AlertsModal
